const typography = {
  h1: {
    fontWeight: "normal",
    fontSize: 34,
    letterSpacing: "-0.24px",
  },
  h2: {
    fontWeight: "normal",
    fontSize: 24,
    letterSpacing: "-0.24px",
  },
  h3: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: "-0.06px",
  },
  h4: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: "-0.06px",
  },
  h5: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: "-0.05px",
  },
  h6: {
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: "-0.05px",
  },
  subtitle1: {
    fontWeight: "normal",
    fontSize: 16,
    letterSpacing: "-0.05px",
  },
  subtitle2: {
    fontWeight: "normal",
    fontSize: 16,
    letterSpacing: "-0.05px",
  },
  body1: {
    fontWeight: "normal",
    fontSize: 14,
    letterSpacing: "-0.05px",
  },
  body2: {
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: "-0.05px",
  },
  button: {
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: "-0.05px",
  },
  caption: {
    fontWeight: "normal",
    fontSize: 12,
    letterSpacing: "-0.05px",
  },
  overline: {
    fontWeight: 500,
  },
};

export default typography;
